import { Box, Grid } from '@mui/material'
import { EthAddress } from '@xylabs/sdk-js'
import { EthAccountButton, FlexCol, RedirectWithQuery } from '@xylabs/sdk-react'
import { useContext } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'

import { BidderLoader, EntityLoader, EntitySettingsLoader, EthersContext } from '../../Contexts'
import {
  EntityCurrencyAllowanceProperty,
  EntityCurrencyBalanceProperty,
  EntityGeotokenBalanceProperty,
  EntityGeotokenCountProperty,
  EntityGeotokenLandAreaProperty,
  EntityTypeProperty,
  Property,
} from '../../Properties'
import { EntityToolbar } from '../../Toolbar'
import WorldBasePage from '../WorldBasePage'
import Lists from './Lists'

const EntityPageBody: React.FC = () => {
  const { id } = useParams()
  const { localAddress, signer, isConnected, provider } = useContext(EthersContext)
  const ethAddress = id ? EthAddress.fromString(id) : null

  console.log(`EntityPage: ${localAddress}`)

  if (!ethAddress) {
    if (localAddress) {
      return <RedirectWithQuery to={`/entity/${localAddress.toString()}`} />
    } else if ((isConnected === false && provider) || signer === null) {
      return <RedirectWithQuery to="/auctions" />
    } else {
      return <Box />
    }
  }

  return (
    <FlexCol marginY={1}>
      <Property title="Address" value={ethAddress.toString()}>
        <EthAccountButton variant="outlined" address={ethAddress} full iconSize={20} toEtherScan={true} />
      </Property>
      <EntityLoader address={ethAddress}>
        <EntitySettingsLoader address={ethAddress}>
          <BidderLoader address={ethAddress}>
            <Grid container>
              <Grid item lg={3} md={6} xs={12}>
                <EntityTypeProperty />
              </Grid>
              <Grid item lg={3} md={6} xs={12}>
                <EntityCurrencyBalanceProperty />
              </Grid>
              <Grid item lg={3} md={6} xs={12}>
                <EntityCurrencyAllowanceProperty />
              </Grid>
              <Grid item lg={3} md={6} xs={12}>
                <EntityGeotokenBalanceProperty />
              </Grid>
              <Grid item lg={3} md={6} xs={12}>
                <EntityGeotokenCountProperty />
              </Grid>
              <Grid item lg={3} md={6} xs={12}>
                <EntityGeotokenLandAreaProperty />
              </Grid>
            </Grid>
            <Lists />
          </BidderLoader>
        </EntitySettingsLoader>
      </EntityLoader>
    </FlexCol>
  )
}

const EntityPage: React.FC = () => {
  const { id } = useParams()
  const { localAddress } = useContext(EthersContext)
  const ethAddress = id ? EthAddress.fromString(id) : null

  console.log(`EntityPage: ${localAddress}`)

  if (!ethAddress) {
    if (localAddress) {
      return <RedirectWithQuery to={`/entity/${localAddress.toString()}`} />
    } else if (localAddress === null) {
      return <RedirectWithQuery to={'/auctions'} />
    }
  }

  return (
    <WorldBasePage toolbar={<EntityToolbar />}>
      <Helmet title={`XYO Entity: ${ethAddress?.toString()}`} />
      <EntityPageBody />
    </WorldBasePage>
  )
}

export default EntityPage
